<template>
  <base-circular-new
    pagetitle="Dados Tablóide"
    :step="3"
    title="Preencha dados do tablóide"
    subtitle="Preencha os dados necessários para gerar o tablóide"
  >
    <div class="row">
      <div class="col s12">
        <div class="card-panel grey lighten-5">
          <div class="row">
            <div class="col s12">
              <div class="input-field">
                <input id="chamada" v-model="chamada" type="text" class maxlength="50" />
                <label for="chamada">Texto de Chamada</label>
                <span
                  class="helper-text"
                  data-error="wrong"
                  data-success="right"
                >Texto de chamada à ser colocado no topo do tablóide.</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <label>Cidades de Abrangência</label>
              <multiselect
                label="nome"
                track-by="id"
                v-model="abrangencia"
                :multiple="true"
                :close-on-select="false"
                :options="cities"
                :placeholder="'Selecione uma ou mais cidades'"
              ></multiselect>

              <!-- <span class="helper-text" data-error="wrong" data-success="right">Selecione uma ou mais cidades de abrangência.</span> -->
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <label>Tema</label>
              <select v-model="theme">
                <option disabled value>Escolha um item</option>
                <option value="vqt">Vem que tem</option>
                <option value="dga">Dia de Gazin</option>
                <option value="ang">Aniversário Gazin</option>
                <option value="oug">Outlet Gazin</option>
                <!-- <option value="dma">Dia das Mães</option> -->
                <option value="mgf">Atacado Gazin Seleção de Ofertas</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <label>Banner</label>
              <select v-model="banner">
                <option disabled value>Escolha um item</option>
                <option value="placa_compra_inteligente">VEMQTEM</option>
                <!-- <option value="placa_mov_10x_s_entr_s_juros">Moveis 10x, Sem Entrada, Sem Juros no Carnê</option>
                                <option value="placa_mov_10x_s_1x9_carne">Moveis 10x (1+9), Sem Juros no Carnê</option>
                                <option value="placa_ar_10x_s_1x9_carne">Ar Condicionado 10x (1+9), Sem Juros no Carnê</option>
                                <option value="placa_ar_10x_s_entr_s_juros">Ar Condicionado, Sem Entrada, Sem Juros no Carnê</option>
                                <option value="placa_col_estof_10x_s_1x9_carne">Colchões 10x (1+9), Sem Juros no Carnê</option>
                                <option value="placa_col_estof_10x_s_entr_s_juros">Colchões 10x, Sem Entrada, Sem Juros no Carnê</option>
                                <option value="placa_infor_10x_s_1x9_carne">Informática 10x (1+9), Sem Juros no Carnê</option>
                                <option value="placa_infor_10x_s_entr_s_juros">Informática 10x, Sem Entrada, Sem Juros no Carnê</option>
                                <option value="placa_smart_10x_s_1x9_carne">Smart 10x (1+9), Sem Juros no Carnê</option>
                                <option value="placa_smart_10x_s_entr_s_juros">Smart 10x, Sem Entrada, Sem Juros no Carnê</option>
                                <option value="placa_td_loja_s_entr_s_juros">Toda loja, Sem entrada, Sem juros</option>
                                <option value="placa_td_loja_s_juros_1x9_carne">Toda loja (1+9), Sem Juros no Carnê</option>
                                <option value="placa_td_loja_s_juros_carne">Toda loja, Sem Juros no Carnê</option>
                                <option value="placa_td_loja_s_juros_cartoes">Toda loja, Sem Juros no Cartão</option>
                                <option value="placa_td_loja_s_juros_0x12_catao">Toda loja em 12x s/entrada s/juros cartão</option>
                                <option value="placa_td_loja_s_juros_0x12_catao">Toda loja em 12x s/entrada s/juros cartão</option>
                <option value="rodapenov">Atacado Banner</option>-->
              </select>
            </div>
          </div>
          <div class="row">
            <div class="col s12">
              <label>Cor de Fundo</label>
              <select v-model="background_color">
                <option disabled value>Escolha um item</option>
                <option value="#FFFFFF">Branco</option>
                <option value="#d6c3d9">Roxo</option>
                <option value="#cad9d6">Verde</option>
                <option value="#fffcd5">Amarelo</option>
                <option value="#e1eefb">Azul</option>
                <option value="#e0a6b2">Nude</option>
              </select>
            </div>
          </div>
          <div class="row">
            <div class="input-field col s6">
              <input id="data_inicio" type="date" placeholder="Data de Início" v-model="dtinicio" />
              <label for="data_inicio">Data de Início</label>
              <span
                class="helper-text"
                data-error="wrong"
                data-success="right"
              >Data de ínicio da validade do tablóide.</span>
            </div>
            <div class="input-field col s6">
              <input id="data_termino" type="date" placeholder="Data de Término" v-model="dtfim" />
              <label for="data_termino">Data de Término</label>
              <span
                class="helper-text"
                data-error="wrong"
                data-success="right"
              >Data de término da validade do tablóide.</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col s12">
        <button @click="generateCircular" class="waves-effect waves-light btn">Gerar!</button>
      </div>
    </div>
  </base-circular-new>
</template>

<script>
import BaseCircularNew from "../shared/base_circular_new/BaseCircularNew.vue";
import Multiselect from "vue-multiselect";

import { BASE_URL_API } from "../../config.js";

export default {
  name: "choice_options",
  components: {
    "base-circular-new": BaseCircularNew,
    Multiselect
  },
  data() {
    return {
      abrangencia: null,
      cities: [],
      items: [],
      chamada: "",
      dtinicio: null,
      dtfim: null,
      theme: "",
      banner: "",
      background_color: ""
    };
  },
  created() {
    this.items = this.$route.params.items;
  },
  mounted() {
    $(document).ready(function() {
      $("select").formSelect();
    });

    const token = localStorage.getItem("user-token");

    this.$http.get(BASE_URL_API + "/cities", { params: { token } }).then(
      response => {
        response.json().then(json => {
          console.log(json);
          this.cities = json.cities;
        });
      },
      response => {
        // error callback
        response.json().then(ret => {
          if (ret.error)
            if (ret.error === "Token expirado.") {
              window.localStorage.removeItem("user-token");
              this.$router.push("/login");
            }
        });
      }
    );
  },
  methods: {
    generateCircular() {
      if (this.chamada === "") {
        this.$swal(
          "Preencha todos os dados",
          "O texto de chamada não foi preenchido!",
          "error"
        );
        return;
      }

      if (this.dtinicio === null) {
        this.$swal(
          "Preencha todos os dados",
          "A data de início não foi preenchida!",
          "error"
        );
        return;
      }

      if (this.dtfim === null) {
        this.$swal(
          "Preencha todos os dados",
          "A data final não foi preenchida!",
          "error"
        );
        return;
      }

      if (this.abrangencia === null) {
        this.$swal(
          "Preencha todos os dados",
          "Não foi selecionada nenhuma cidade na abrangência",
          "error"
        );
        return;
      }

      const token = localStorage.getItem("user-token");

      this.$http
        .post(BASE_URL_API + "/generate-circular", {
          token,
          produtos: this.items
        })
        .then(
          response => {
            response.json().then(json => {
              this.$swal({
                title:
                  "Na próxima tela, aguarde a imagem ser gerada. Após isso, basta clicar no botão Salvar Imagem.",
                showCancelButton: false
              }).then(result => {
                if (result.value) {
                  // handle Confirm button click
                  // result.value will contain `true` or the input value
                  // console.log(json);
                  let name_route = "";
                  if (this.$route.params.qtd_itens === 2) {
                    name_route = "gera_circular_2x";
                  } else if (this.$route.params.qtd_itens === 3) {
                    name_route = "gera_circular_3x";
                  } else if (this.$route.params.qtd_itens === 4) {
                    name_route = "gera_circular_4x";
                  } else if (this.$route.params.qtd_itens === 5) {
                    name_route = "gera_circular_5x";
                  } else if (this.$route.params.qtd_itens === 6) {
                    name_route = "gera_circular_6x";
                  } else if (this.$route.params.qtd_itens === 7) {
                    name_route = "gera_circular_7x";
                  } else if (this.$route.params.qtd_itens === 8) {
                    name_route = "gera_circular_8x";
                  } else if (this.$route.params.qtd_itens === 9) {
                    name_route = "gera_circular_9x";
                  }

                  this.$router.push({
                    name: name_route,
                    params: {
                      items: this.items,
                      abrangencia: this.abrangencia,
                      chamada: this.chamada,
                      dtinicio: this.dtinicio,
                      dtfim: this.dtfim,
                      theme: this.theme,
                      banner: this.banner,
                      background_color: this.background_color
                    }
                  });
                } else {
                  // handle dismissals
                  // result.dismiss can be 'cancel', 'overlay', 'esc' or 'timer'
                }
              });
            });
          },
          response => {
            // error callback
            response.json().then(ret => {
              if (ret.error)
                if (ret.error === "Token expirado.") {
                  window.localStorage.removeItem("user-token");
                  this.$router.push("/login");
                }
            });
          }
        );
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.multiselect__content-wrapper * {
  position: relative;
  z-index: 6;
}

.multiselect--active {
  z-index: 10;
}
</style>





// WEBPACK FOOTER //
// src/components/choice_options/ChoiceOptions.vue